
































import Vue from "vue";
import { mapState } from "vuex";
import LogoTextBlock from "@/components/blocks/LogoTextBlock.vue";
import experienceList from "@/assets/contents/WorkExperienceContent";

export default Vue.extend({
    name: "WorkExperienceSection",
    components: {
        LogoTextBlock,
    },
    props: {
    },
    data() {
        return {
            sectionTitle: "Work Experience",
            experienceList,
            imageType: "none",
            hideBullet: false,
        };
    },
    computed: mapState([
        "oneColumnGrid",
    ]),
});
